import { render, staticRenderFns } from "./IssueItemModal.vue?vue&type=template&id=5f76330d&"
import script from "./IssueItemModal.vue?vue&type=script&lang=js&"
export * from "./IssueItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports